import React from 'react';
import { ScanBarcode, Coins, CornerUpLeft, Trash2, UserMinus } from 'lucide-react';
import { ScanMode } from '../types';

interface ModeSelectorProps {
  allowedModes: ScanMode[];
  currentMode: ScanMode;
  onModeChange: (mode: ScanMode) => void;
}

export const ModeSelector: React.FC<ModeSelectorProps> = ({
  allowedModes,
  currentMode,
  onModeChange,
}) => {
  const modes: Array<{ mode: ScanMode; icon: React.ReactNode; label: string }> = [
    { mode: 'COUNT', icon: <ScanBarcode size={18} className="mb-1" />, label: 'Leltár' },
    { mode: 'SALE', icon: <Coins size={18} className="mb-1" />, label: 'Kassza' },
    { mode: 'RETURN', icon: <CornerUpLeft size={18} className="mb-1" />, label: 'Visszárú' },
    { mode: 'SCRAP', icon: <Trash2 size={18} className="mb-1" />, label: 'Selejt' },
    { mode: 'INTERNAL', icon: <UserMinus size={18} className="mb-1" />, label: 'Saját' },
  ];

  return (
    <div className={`grid gap-2 mb-4 ${allowedModes.length === 1 ? 'grid-cols-1' : 'grid-cols-5'}`}>
      {modes
        .filter((m) => allowedModes.includes(m.mode))
        .map(({ mode, icon, label }) => (
          <button
            key={mode}
            onClick={() => onModeChange(mode)}
            className={`flex flex-col items-center p-2 rounded-lg text-[10px] md:text-xs font-bold uppercase transition ${
              currentMode === mode
                ? mode === 'COUNT'
                  ? 'bg-primary text-white shadow-md'
                  : mode === 'SALE'
                    ? 'bg-primary text-white shadow-md'
                    : mode === 'RETURN'
                      ? 'bg-purple-600 dark:bg-purple-500 text-white shadow-md'
                      : mode === 'SCRAP'
                        ? 'bg-red-600 dark:bg-red-500 text-white shadow-md'
                        : 'bg-orange-500 dark:bg-orange-400 text-white shadow-md'
                : 'bg-card text-slate-500 dark:text-gray-400 border dark:border-gray-700 hover:bg-slate-50 dark:hover:bg-gray-700'
            }`}
          >
            {icon}
            {label}
          </button>
        ))}
    </div>
  );
};
